export default __webpack_public_path__ + "static/media/web3js.44e2eb57.png";